export const driveIconSize = { width: '63px', height: 'auto' };
